import httpRequest from "../../../axios/index";
import { ADMIN_LOGIN } from "../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";

const AdminLoginApi = async (setLoading, data) => {
  try {
    setLoading(true);
    const resp = await httpRequest.post(`${ADMIN_LOGIN}`, { user: data });
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

export { AdminLoginApi };
